
export let axiosErrorHandle = {
  handle: null
}


export function setAxiosErrorHandle(handle) {
  axiosErrorHandle.handle = handle
}
